import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import classnames from 'classnames';

import NotificationIconWhite from 'core/assets/svg/alert-white-filled.svg';
import NotificationIconOrange from 'core/assets/svg/info-orange.svg';
import NotificationIconGreen from 'core/assets/svg/alert-green.svg';
import icInfoIconGreen from 'core/assets/svg/ic-info-dark.svg';
import icInfoIconWhite from 'core/assets/svg/ic-info-white.svg';
import darkInfoIcon from 'core/assets/svg/ic-info-black.svg';
import { Card } from '../card';
import { Label } from '../label';
import useStyles from './notification-card.styles';

const icons = {
  primary: NotificationIconWhite,
  secondary: NotificationIconOrange,
  tertiary: NotificationIconWhite,
  quaternary: NotificationIconWhite,
  quinary: NotificationIconOrange,
  light: darkInfoIcon,
  infoGreen: icInfoIconGreen,
  infoWhite: icInfoIconWhite
};

const NotificationCard = ({
  children,
  type,
  noBackground,
  className,
  icon: ic,
  header,
  iconByHeader,
  iconSize,
  hideIcon,
  iconClassName,
  noShadow
}) => {
  const classes = useStyles({ noShadow });
  const icon = ic || icons[type];

  // using noBackground prop to return an inline icon and text notification instead of the whole card
  if (noBackground) {
    return (
      <Grid className={classnames(classes.noBackground, classes[type], className)}>
        {!hideIcon && (
          <img src={icon} className={classnames(classes[iconSize], iconClassName)} alt="Notification Icon" />
        )}
        {children}
      </Grid>
    );
  }

  if (header) {
    return iconByHeader ? (
      <Card className={classnames(classes.columnContainer, classes[type], className)}>
        <Grid className={classes.headerRow}>
          {!hideIcon && (
            <img src={icon} className={classnames(classes[iconSize], iconClassName)} alt="Notification Icon" />
          )}
          <Label type="darkSmall" fontWeight="600" className={classes.header}>
            {header}
          </Label>
        </Grid>

        <Grid className={classes.text}>
          <Grid className={classes.notificationContentContainer}>{children}</Grid>
        </Grid>
      </Card>
    ) : (
      <Card className={classnames(classes.sideBySideContainer, classes[type], className)}>
        {!hideIcon && (
          <img src={icon} className={classnames(classes[iconSize], iconClassName)} alt="Notification Icon" />
        )}
        <Grid className={classes.text}>
          <Label type="darkSmall" fontWeight="600">
            {header}
          </Label>
          <Grid className={classes.notificationContentContainer}>{children}</Grid>
        </Grid>
      </Card>
    );
  }
  return (
    <Card className={classnames(classes.container, classes[type], className)}>
      <Grid className={classes.notificationContentContainer}>
        {!hideIcon && (
          <img src={icon} className={classnames(classes[iconSize], iconClassName)} alt="Notification Icon" />
        )}
        {children}
      </Grid>
    </Card>
  );
};

NotificationCard.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf([
    'primary',
    'secondary',
    'tertiary',
    'quaternary',
    'quinary',
    'light',
    'outline',
    'infoGreen',
    'infoWhite'
  ]),
  icon: PropTypes.string,
  iconSize: PropTypes.oneOf(['icon', 'icon16']),
  noBackground: PropTypes.bool,
  className: PropTypes.string,
  header: PropTypes.string,
  iconByHeader: PropTypes.bool,
  hideIcon: PropTypes.bool,
  iconClassName: PropTypes.string,
  noShadow: PropTypes.bool
};

NotificationCard.defaultProps = {
  type: 'primary',
  icon: null,
  iconSize: 'icon',
  noBackground: false,
  className: undefined,
  header: undefined,
  iconByHeader: false,
  hideIcon: false,
  noShadow: false
};

export default NotificationCard;
